export default __webpack_public_path__ + "static/media/mikraLogo.da0cc862.svg";